.container {
    display: flex;
    align-items: center;
    gap: 6px;
}

.status {
    color: #a4262c;
    font-size: 13px;
}
